<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                :rules="workOrderTravelFormRules"
                ref="workOrderTravelForm"
                class=""
            >
                <van-field
                    :required="true"
                    v-model="workOrderTravelForm.processing_name"
                    :name="'processing_uid'"
                    label="实施人"
                    placeholder="请选择"
                    :rules="workOrderTravelFormRules.processing_uid"
                    error-message-align="right"
                    is-link
                    readonly
                >
                </van-field>
                <van-field
                    :required="true"
                    v-model="workOrderTravelForm.start_date_text"
                    :name="'start_date'"
                    label="出发时间"
                    placeholder="请选择时间"
                    :rules="workOrderTravelFormRules.start_date"
                    error-message-align="right"
                    is-link
                    readonly
                    @click="handleClickDateFieldlink()"
                >
                </van-field>
                <van-field
                    v-model="workOrderTravelForm.travel_note"
                    name="travel_note"
                    label="说明"
                    placeholder="请输入"
                    error-message-align="right"
                    type="textarea"
                    :rows="5"
                    maxlength="500"
                    input-align="left"
                    class="vertical_input_wrap"
                >
                </van-field>
            </van-form>
            <div class="add_approval_select_process" v-if="isApproval === 1">
                <approveProcessSelect
                    ref="approveProcessSelectRef"
                    :approval_node_list="approval_node_list"
                ></approveProcessSelect>
            </div>
        </div>
        <div class="add_footer_wrap mobile_add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>
        <!--_年_月_日 日期选择-->
        <van-calendar
            v-model="showDateCalendar"
            color="#2990FF"
            :min-date="dateCalendarMin"
            :max-date="dateCalendarMax"
            @confirm="handleDateCalenderConfirm"
        />
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            z-index="1000"
            v-if="handleRadioPicker"
            :show="handleRadioPicker"
            @click="handleRadioPicker = false"
        >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        class="radio_option_item"
                        v-for="item in radioOptions"
                        :key="item.value"
                        @click="handleClickOption(item)"
                    >
                        {{ item.label }}
                    </li>
                    <div class="cancel_btn" @click="handleClickRadioCancel">取消</div>
                </ul>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { formatDate } from "@/utils";
import { GetUserList, workOrderTravel, workOrderSetDetail, getApprovalNodes } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
import {EventBus} from '@/utils/eventBus';
export default {
    name: "WorkOrderTravel",
    components: {ReturnNavBar, approveProcessSelect},
    data() {
        return {
            loading: false,
            workorder_id: this.$route.query.id,
            workorder_num: this.$route.query.workorder_num,
            assign_id: this.$route.query.assign_id,
            travelInfo: this.$route.query.travelInfo,
            workOrderTravelForm: {
                processing_uid: this.owner_uid,
                processing_name: this.owner_name,
                start_date: "",
                start_time: 1,
                start_date_text: "",
                travel_note: "",
            },
            workOrderTravelFormRules: {
                processing_uid: [{ required: true, message: "请选择", trigger: ["blur", "change"] }],
                start_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }],
            },
            isApproval: 0,
            approval_node_list: [],

            showDateCalendar: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            handleRadioPicker: false,
            radioOptions: [
                { label: "上午", value: 1 },
                { label: "下午", value: 2 },
            ],

            btnDisabled: false,
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        userList() {
            const list = [
                {
                    uid: this.userInfo && this.userInfo.user && this.userInfo.user.id,
                    name: this.userInfo && this.userInfo.user && this.userInfo.user.name,
                },
            ];
            return list;
        },
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
        owner_name() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.name;
        },
    },
    created() {
        this.workOrderTravelForm.processing_uid = this.owner_uid;
        this.workOrderTravelForm.processing_name = this.owner_name;
        this.getWorkOrderSetDetail()
    },
    methods: {
        // 获取实施出发是否需要审批
        getWorkOrderSetDetail() {
            this.loading = true;
            workOrderSetDetail().then((res) => {
                this.isApproval = res.data ? res.data.is_travel_approve : 0;
                if (this.isApproval === 1) {
                    getApprovalNodes({
                        approval_type: "workorder_travel",
                    })
                        .then((res) => {
                            if (res.code === 200) {
                                this.approval_node_list = res.data;
                                this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);
                            } else {
                                this.$toast(res.message);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;
                }
            });
        },
        handleClickDateFieldlink() {
            this.showDateCalendar = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.currentDate = date;
            this.showDateCalendar = false;
            this.handleRadioPicker = true;
        },
        // 选择时间段确认
        handleClickOption(item) {
            this.$set(this.workOrderTravelForm, "start_date", formatDate(this.currentDate, "date"));
            this.$set(this.workOrderTravelForm, "start_time", item.value);
            this.$set(
                this.workOrderTravelForm,
                "start_date_text",
                formatDate(this.currentDate, "date") + "-" + item.label
            );
            this.handleRadioPicker = false;
        },
        // 选择取消
        handleClickRadioCancel() {
            this.currentDate = null;
            this.handleRadioPicker = false;
        },
        handleClickConfirm() {
            this.$refs.workOrderTravelForm.validate().then(() => {
                if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false;
                const workOrderTravelForm = JSON.parse(JSON.stringify(this.workOrderTravelForm));
                let travel_date = workOrderTravelForm.start_date_text
                delete workOrderTravelForm.start_date_text;
                const params = {
                    workorder_id: this.workorder_id,
                    workorder_num: this.workorder_num,
                    assign_id: this.assign_id,
                    ...workOrderTravelForm,
                    ...this.travelInfo,
                    node_list: this.approval_node_list,
                    travel_date:travel_date
                };
                this.btnDisabled = true;
                workOrderTravel(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    EventBus.$emit('workOrderAddUpdated');
                                    this.$router.go(-1);
                                    this.btnDisabled = false;
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
}
.add_approval_select_process {
    padding: 10px 16px;
    background: #fff;
}
</style>
